/*
 * @Author: your name
 * @Date: 2021-05-21 16:09:59
 * @LastEditTime: 2021-10-21 15:34:36
 * @LastEditors: Please set LastEditors
 * @Description: 头部导航所对应的路由组件
 * @FilePath: \NavDemo\src\router.config.js
 */
export default [{
    'path': '/',
    'component': 'layout/Layout',
    'redirect': {
        "name": "CustomPage"
    },
  "children": [
    // {
      
    //     "path": "/HomePath",
    //     "name": "HomePath",
    //     "component": 'home/HomePath',
    //     "meta": { "key": "HomePath" }
    // },
      {
        "path": "/CustomPage",
        "name": "CustomPage",
        "component": 'customPage/CustomPage',
        "meta": { "key": "CustomPage" },
        
          // "children": [
          //   {
          //     "path": "/CustomPage/product",
          //     "name": "product",
          //     "component": 'product/XinChuang',
          //     "meta": { "key": "product" },
              "children": [{
                "path": "xinchuang",
                "name": "xinchuang",
                "component": 'product/XinChuang',
                "meta": { "key": "xinchuang" },
                },{
                  "path": "mobile",
                  "name": "mobile",
                  "component": 'product/Mobile',
                  "meta": { "key": "mobile" },
                  }]
          //     },
          // ]
      
    }]
}];